import { render, staticRenderFns } from "./BankCatch.vue?vue&type=template&id=48821555&scoped=true&"
import script from "./BankCatch.vue?vue&type=script&lang=js&"
export * from "./BankCatch.vue?vue&type=script&lang=js&"
import style0 from "./BankCatch.vue?vue&type=style&index=0&id=48821555&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48821555",
  null
  
)

export default component.exports